import React from 'react';
import styled, { css } from 'styled-components';

export const Menu = styled.div`
  display: flex;
  position: relative;
`;

export const SeparatorOuter = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 24px;
  justify-content: center;
  padding: 0 4px;
`;

export const SeparatorInner = styled.div`
  border-left: 1px solid ${p => p.theme.colors.gray300};
  height: 24px;
  width: 1px;
`;

export function Separator() {
  return (
    <SeparatorOuter>
      <SeparatorInner />
    </SeparatorOuter>
  );
}

export const Item = styled.span`
  align-items: center;
  border: 1px solid ${p => p.theme.colors.white};
  border-radius: 4px;
  color: ${p => p.theme.colors.gray900};
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  height: 25px;
  justify-content: center;
  margin-bottom: 0;
  margin-left: 4px;
  margin-right: 4px;
  text-align: center;
  width: 25px;
  &:hover {
    border: 1px solid ${p => p.theme.colors.gray200};
  }
  & .placeholderIcon {
    fill: ${p => p.theme.colors.gray900};
    height: 14px;
    width: 14px;
  }
  ${p => p.isActive && activeItem};
`;

const activeItem = css`
  border: 1px solid ${p => p.theme.colors.green400};
  color: ${p => p.theme.colors.green400};
  &:hover {
    border: 1px solid ${p => p.theme.colors.green400};
  }
  & .placeholderIcon {
    fill: ${p => p.theme.colors.green400};
  }
  & .quoteIcon {
    fill: ${p => p.theme.colors.green400};
  }
`;

export const ExpandableItem = styled(Item)`
  width: 40px;
`;

export const ExpandableItemMenu = styled.div`
  background-color: ${p => p.theme.colors.white};
  border: 1px solid ${p => p.theme.colors.gray200};
  border-radius: ${p => p.theme.borderRadius.default};
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  margin-top: ${p => p.theme.spacing.xsmall};
  padding: 0;
  position: absolute;
  z-index: 3;
`;

export const ExpandableItemMenuItem = styled.div`
  cursor: pointer;
  padding: ${p => p.theme.spacing.medium} ${p => p.theme.spacing.medium};
  &:hover {
    color: ${p => p.theme.colors.green400};
  }
  ${p => p.isActive && activeExpandableItem};
`;

const activeExpandableItem = css`
  color: ${p => p.theme.colors.green400};
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/lib/slate/slate_styles_menu.styles.jsx